@if (isOpen) {
  <div
    class="modal-backdrop"
    (click)="onBackdropClick($event)"
    [@backdrop]
  >
    <div class="modal-panel" (click)="$event.stopPropagation()" [@panel]>
      <button
        type="button"
        class="modal-close"
        (click)="emitClose()"
        aria-label="Close"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>

      <h2 class="modal-title">Join our Mailing List</h2>
      <p class="modal-instructions">Sign up for the <span class="nerd-orange">nerd</span> mailing list and we'll keep you posted on news, new Decks, and updates.</p>

      @if (showForm()) {
        <form [formGroup]="form" (ngSubmit)="onSubmit()" class="modal-form">
          <div class="name-fields-row">
            <div class="form-field">
              <label for="signup-firstName">First Name <span class="required">*</span></label>
              <input
                id="signup-firstName"
                type="text"
                formControlName="firstName"
                pInputText
                class="full-width"
              />
              @if (form.get('firstName')?.invalid && form.get('firstName')?.touched) {
                <span class="field-error">First name is required.</span>
              }
            </div>
            <div class="form-field">
              <label for="signup-lastName">Last Name <span class="required">*</span></label>
              <input
                id="signup-lastName"
                type="text"
                formControlName="lastName"
                pInputText
                class="full-width"
              />
              @if (form.get('lastName')?.invalid && form.get('lastName')?.touched) {
                <span class="field-error">Last name is required.</span>
              }
            </div>
          </div>
          <div class="form-field">
            <label for="signup-email">Email Address <span class="required">*</span></label>
            <input
              id="signup-email"
              type="email"
              formControlName="email"
              pInputText
              class="full-width"
            />
            @if (form.get('email')?.invalid && form.get('email')?.touched) {
              <span class="field-error">
                @if (form.get('email')?.errors?.['required']) {
                  Email is required.
                } @else {
                  Please enter a valid email address.
                }
              </span>
            }
          </div>
          <div class="form-field">
            <label for="signup-nerdOut">Everyone's a <span class="nerd-orange">nerd</span> about something. What's your favorite thing to nerd out about? <span class="required">*</span></label>
            <textarea
              id="signup-nerdOut"
              formControlName="nerdOutAbout"
              pTextarea
              class="full-width"
              rows="3"
            ></textarea>
            @if (form.get('nerdOutAbout')?.invalid && form.get('nerdOutAbout')?.touched) {
              <span class="field-error">This field is required.</span>
            }
          </div>
          <div class="form-field checkbox-field">
            <span class="checkbox-wrap">
              <p-checkbox
                inputId="signup-agree"
                formControlName="agreeToEmails"
                [binary]="true"
              ></p-checkbox>
            </span>
            <label for="signup-agree" class="checkbox-label">By signing up, I agree to receive emails from <span class="nerd-orange">nerd</span> with news and updates. I can unsubscribe at any time.</label>
          </div>
          @if (form.get('agreeToEmails')?.invalid && form.get('agreeToEmails')?.touched) {
            <span class="field-error">You must agree to receive emails.</span>
          }

          @if (errorMessage(); as msg) {
            <p class="form-error">{{ msg }}</p>
          }

          <div class="modal-footer">
            <div class="footer-actions">
              <button
                type="button"
                class="btn btn-secondary"
                (click)="onCancel()"
                [disabled]="submitting()"
              >
                Cancel
              </button>
              <button
                type="submit"
                class="btn btn-primary"
                [disabled]="form.invalid || submitting()"
              >
                {{ submitting() ? 'Signing up…' : "I'm In!" }}
              </button>
            </div>
          </div>
        </form>
      } @else {
        <div class="modal-success-content">
          <p class="modal-success-thanks">Thank you for your submission.</p>
        </div>
        <div class="modal-footer">
          <p class="footer-success">
            <span class="success-icon" aria-hidden="true">✓</span>
            <span class="footer-success-text">{{ duplicate() ? "You're already on the list!" : "You're in! We'll be in touch." }}</span>
          </p>
          <div class="footer-actions">
            <button type="button" class="btn btn-primary" (click)="emitClose()">Close</button>
          </div>
        </div>
      }
    </div>
  </div>
}
